// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table, th, td {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

svg[viewBox] {
    overflow: visible;
}

svg[viewBox], path[d] {
    pointer-events: none;
}

input::-ms-reveal {
    display: none;
}

input::-ms-clear {
    display: none;
}`, "",{"version":3,"sources":["webpack://./web/global.css"],"names":[],"mappings":"AAAA;IACI,gGAAgG;AACpG;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB","sourcesContent":["table, th, td {\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n}\n\nsvg[viewBox] {\n    overflow: visible;\n}\n\nsvg[viewBox], path[d] {\n    pointer-events: none;\n}\n\ninput::-ms-reveal {\n    display: none;\n}\n\ninput::-ms-clear {\n    display: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
